export default {
  baseUrl: '//www.codoon.com',
  raceUrl: '//race.codoon.com/v2/race/api',
  trainUrl: 'https://rn.codoon.com/app/rnapp/basic_training?page_type=basic_training&page_id=27',
  awardUrl: 'https://s1.codooncdn.com/operation-tools/internal-user/2019-02-27T15.46.52/1280x480x114417xhYkpbqTa2dV7WCvX2i.jpeg'
}